// consumer.js
import { createConsumer } from "@rails/actioncable"

let sharedConsumer = null

/**
 * getSharedConsumer: returns the singleton consumer.
 * If it doesn’t exist or the token changed, it creates or recreates the consumer.
 */
export function getSharedConsumer(jwt) {
	// If we haven’t created a shared consumer yet, or the token is different,
	// disconnect and create a new one.
	if (!sharedConsumer || !sharedConsumer.url.includes(jwt)) {
		if (sharedConsumer) {
			sharedConsumer.disconnect()
		}
		sharedConsumer = createConsumer(`${window.action_url}cable?token=${jwt}`)
	}

	return sharedConsumer
}

/**
 * createNewConsumer: always creates and returns a new consumer.
 * Useful if you absolutely need a separate connection.
 */
export function createNewConsumer(jwt) {
	return createConsumer(`${window.action_url}cable?token=${jwt}`)
}
export function createNewGroupConsumer(jwt, group_id) {
	return createConsumer(`${window.action_url}cable?token=${jwt}&group_id=${group_id}`)
}
